import {Locations as DataSourceLocations} from "../admin/venueManagement/settings/dataSources/DataSourceSettings.Locations";

export const Locations = DataSourceLocations;
export default Locations;